import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { validations } from '../../utils/validations';
import { FormContainer } from '../common/form/FormContainer';
import { SubmitButton } from '../common/form/SubmitButton';
import { SectionHeader } from '../common/SectionHeader';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../common/basic/QcsModalBox';
import { DatePicker } from '../common/form/DatePicker';
import { Input } from '../common/form/Input';
import { isDateDisabled } from '../../utils/date';
import { QuestionnaireVersionDto } from '@api/models/questionnaire/QuestionnaireVersionDto';
import { CopyVersionRequest } from '@api/models/version/CopyVersionRequest';
import { questionnaireVersionService } from '@api/services/services';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';

interface Props {
  versionToCopy?: QuestionnaireVersionDto | null;
  onClose: () => void;
  reloadQuestionnaireVersionList: () => void;
}

export const CopyVersionModal: FC<Props> = ({ versionToCopy, onClose, reloadQuestionnaireVersionList: reloadTrainingVersionList }) => {
  const { t } = useTranslation();

  const handleSubmit = async (data: CopyVersionRequest) => {
    await questionnaireVersionService.copyQuestionnaireVersion(versionToCopy!.id!, data);
    reloadTrainingVersionList();
    onClose();
  };

  return (
    <QcsModal open={!!versionToCopy} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title={'questionnaire.copy.addVersion'} />
        <FormikDebounce<CopyVersionRequest>
          initialValues={{
            validFrom: '',
            versionNote: '',
          }}
          validationSchema={Yup.object().shape({
            validFrom: validations.stringDateNotPastOrTodayRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <DatePicker
                name="validFrom"
                label={t('questionnaire.validFrom')}
                disablePast
                disableHighlightToday
                shouldDisableDate={isDateDisabled}
                required
              />
              <Input name="versionNote" label={t('questionnaire.versionNote')} maxLength={250} multiline={true} rows={4} />

              <ShowError resource={resources.copyQuestionnaireVersion} />
              <SubmitButton />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
